import React, { useState, useRef, useEffect, ReactNode } from "react";
import Button from "../Button";
import styled from "styled-components";
import { ReactComponent as Filter } from "../../assets/filter.svg";
import Modal from "../Modal";

// const ModalBackdrop = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: rgba(0, 0, 0, 0.5); /* Translucent background */
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 99999999; /* To ensure it's behind the modal */
// `;

// const Modal = styled.div`
//   display: flex;
//   flex-direction: column;
//   min-width: 400px;
//   max-width: 600px;
//   background-color: white;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//   z-index: 10;
//   padding: 16px;
//   border-radius: 8px;
//   border: 1px solid #f1effb;
// `;

interface ReusableModalButtonProps {
  children: ReactNode;
  buttonText?: string;
  icon?: ReactNode;
  onClose?: () => void;
  changeCount?: number;
}

const ReusableModalButton: React.FC<ReusableModalButtonProps> = ({
  children,
  buttonText = "Filter",
  icon = false,
  onClose,
  changeCount,
}) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const buttonRef = useRef<HTMLDivElement | null>(null);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      <div ref={buttonRef}>
        <Button
          icon={icon ? <Filter fill="#3F3F3F" /> : null}
          style={{
            backgroundColor: "#fff",
            borderRadius: 8,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "#F1EFFB",
            color: "#3F3F3F",
          }}
          onClick={showModal}
        >
          {` ${buttonText}${changeCount ? `(${changeCount})` : ""}`}
        </Button>
      </div>

      {isModalVisible && (
        <Modal
          title="Filter"
          isOpen={isModalVisible}
          halfWidth={true}
          onClose={() => {
            setIsModalVisible(false);
          }}
        >
          {children}
        </Modal>
      )}
    </>
  );
};

export default ReusableModalButton;
